const { findPhoneNumbersInText } = require('libphonenumber-js');

exports.doesContainPhoneNumber = (text) => {
  const regions = ['US', 'CA', 'GB', 'FR', 'DE', 'ES', 'AU'];

  return regions.some((region) => {
    const results = findPhoneNumbersInText(text, region);
    return 0 < results.length;
  });
};
